function DateAdd(interval,number,date)
{
/*
 *--------------- DateAdd(interval,number,date) -----------------
 * DateAdd(interval,number,date) 
 * 参数:interval,字符串表达式，表示要添加的时间间隔.
 * 参数:number,数值表达式，表示要添加的时间间隔的个数.
 * 参数:date,时间对象.
 * 返回:新的时间对象.
 * var now = new Date();
 * var newDate = DateAdd("d",5,now);
 *--------------- DateAdd(interval,number,date) -----------------
 */
    switch(interval)
    {
        case "y" : {
            date.setFullYear(date.getFullYear()+number);
            return date;
            break;
        }
        case "q" : {
            date.setMonth(date.getMonth()+number*3);
            return date;
            break;
        }
        case "m" : {
            date.setMonth(date.getMonth()+number);
            return date;
            break;
        }
        case "w" : {
            date.setDate(date.getDate()+number*7);
            return date;
            break;
        }
        case "d" : {
            date.setDate(date.getDate()+number);
            return date;
            break;
        }
        case "h" : {
            date.setHours(date.getHours()+number);
            return date;
            break;
        }
        case "m" : {
            date.setMinutes(date.getMinutes()+number);
            return date;
            break;
        }
        case "s" : {
            date.setSeconds(date.getSeconds()+number);
            return date;
            break;
        }
        default : {
            date.setDate(d.getDate()+number);
            return date;
            break;
        }
    }
}

function FormatDate(time,format='YY/MM/DD hh:mm:ss'){
    var date = new Date(time);
    var year = date.getFullYear(),
        month = date.getMonth()+1,//月份是从0开始的
        day = date.getDate(),
        hour = date.getHours(),
        min = date.getMinutes(),
        sec = date.getSeconds();
    var preArr = Array.apply(null,Array(10)).map(function(elem, index) {
        return '0'+index;
    });//开个长度为10的数组 格式为 ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09"]
 
    var newTime = format.replace(/YY/g,year)
        .replace(/MM/g,preArr[month]||month)
        .replace(/DD/g,preArr[day]||day)
        .replace(/hh/g,preArr[hour]||hour)
        .replace(/mm/g,preArr[min]||min)
        .replace(/ss/g,preArr[sec]||sec);
 
    return newTime;
};

export {
    DateAdd,
    FormatDate
}